import type { TranslationKeys } from './index';

export const uk: TranslationKeys = {
  login_hi: 'Раді тебе бачити! 👋',
  login_title: 'Увійти',
  login_label: 'Вхід',
  login_title2: 'Увійди у свій кабінет пацієнта',
  login_choose: 'Впиши свій номер телефону, а ми вишлемо тобі одноразовий код-пароль',
  login_no_password_hint: 'Вхід без пароля — швидко та безпечно',
  phone_placeholder: 'Телефон*',
  login_sub_email: 'Введіть e-mail і пароль',
  forgot: 'Не памʼятаєш пароль?',
  login_by_phone: 'Скористайся входом за номером телефону',
  or: 'або',
  password: 'Пароль',
  login_btn: 'Увійти',
  cont_google: 'Продовжити з Google',
  cont_apple: 'Продовжити з Apple',
  no_account: 'Не маєш акаунту?',
  no_account_sub: 'Зареєструйся — наступні замовлення оформиш швидше, а візити й документи будуть в одному місці',
  create_account: 'Створити акаунт',
  reg_title: 'Створити акаунт',
  reg_sub: 'Вкажи свої дані, щоб створити акаунт пацієнта.',
  firstname: 'Ім\'я',
  lastname: 'Прізвище',
  id_doc: 'PESEL або паспорт',
  pesel: 'PESEL',
  passport: 'Паспорт',
  reg_btn: 'Створити акаунт',
  consent1: 'Приймаю Регламент і Політику конфіденційності',
  consent2: 'Даю згоду на обробку моїх даних для надання медичних послуг',
  reg_phone_title: 'Створити акаунт',
  reg_phone_sub: 'Введіть номер телефону, а ми надішлемо вам код SMS',
  reg_firstname: 'Ім\'я',
  reg_lastname: 'Прізвище',
  consent1_text: 'Приймаю <a href="/regulamin/">Регламент</a> та <a href="/polityka-prywatnosci/">Політику конфіденційності</a>',
  consent2_text: 'Надаю згоду на обробку моїх даних з метою надання медичних послуг',
  no_account_yet_msg: 'Конто пацієнта створимо автоматично після першої оплати — тоді ввійдеш за SMS-кодом. Оформи замовлення нижче.',
  login_no_account_msg: 'Акаунт з таким номером телефону не знайдено. Перейдіть до реєстрації',
  err_firstname_empty: 'Введіть ім\'я',
  err_lastname_empty: 'Введіть прізвище',
  err_consent_required: 'Обов\'язкова згода',
  reg_login_link: 'Вже маю акаунт — увійти',
  otp_title: 'Введіть код з SMS',
  otp_sub: 'Ми надіслали 4-значний код на твій номер телефону',
  confirm: 'Підтвердити',
  resend: 'Надіслати код ще раз',
  phone_label: 'Номер телефону',
  send_sms_btn: 'Надіслати код SMS',
  change_number: 'Змінити номер',
  otp_sent_hint: 'Ми надіслали код на {phone}',
  resend_timer: 'Відправити знову ({time})',
  err_phone_empty: 'Введіть номер телефону',
  err_phone_format: 'Невірний формат номеру',
  err_sms_failed: 'Не вдалося відправити код. Спробуйте ще раз',
  err_otp_invalid: 'Невірний код. Спробуйте ще раз',
  err_otp_expired: 'Код застарів — надішли новий',
  err_otp_rate_limit: 'Забагато спроб. Зачекайте хвилину',
  reset_pw_title: 'Скинути пароль',
  reset_pw_sent: 'Якщо акаунт існує, ми відправили посилання',
  login_with_sms: 'Увійти за допомогою SMS',
  login_with_email: 'Увійти за допомогою e-mail та паролю',
  err_network: 'Виникла помилка мережі. Якщо ви отримали SMS-код, перейдіть далі.',
  err_fill_all_to_enter_code: 'Заповніть усі поля правильно, щоб мати можливість ввести код',
  err_phone_to_enter_code: 'Введіть номер телефону, щоб мати можливість ввести код.',
  btn_have_code: 'Я вже маю SMS-код',
  thanks_title: 'Дякуємо за оплату!',
  thanks_sub: 'Замовлення оплачено. Підтвердження надіслали на e-mail. Акаунт пацієнта вже готовий.',
  go_account: 'Перейти в акаунт',
  go_back: 'Повернутися',
  nav_cons: 'Мої консультації',
  nav_cons_short: 'Консультації',
  nav_terapia: 'Моя терапія',
  nav_terapia_short: 'Терапія',
  nav_uslugi: 'Послуги',
  nav_uslugi_s: 'Послуги',
  nav_umow: 'Записатись',
  btn_umow: 'Записатись',
  nav_doc: 'Документи',
  nav_dane: 'Мої дані',
  logout: 'Вийти',
  greet_title: 'Вітаємо, {name}! 👋',
  greet_sub: 'Твої візити, дані й документи — усе в одному місці',
  cons_actual: 'Актуальні',
  cons_done: 'Завершені',
  status_upcoming: 'Майбутня',
  status_done: 'Завершена',
  cons_cancelled: 'Анульовані',
  status_cancelled: 'Анульована',
  status_pending: 'Очікує на оплату',
  pay_for_visit: 'Оплатити візит',
  status_nieudane: 'Невдала',
  contact_support: 'Зв’язатись з нами',
  order_no: '№ замовлення',
  show_more: 'Переглянути більше',
  show_less: 'Згорнути',
  weight: 'Вага',
  by_phone: 'По телефону',
  online: 'Онлайн',
  reschedule: 'Перенести візит',
  rebook: 'Повторний запис',
  empty_cons: 'У тебе ще немає візитів',
  empty_cons_sub: 'Почни з першої консультації — ми поруч 💜',
  empty_cons_cta: 'Записатись на візит',
  visit_summary: 'Підсумок візиту',
  cons_empty_tab: 'У цій вкладці немає консультацій.',
  cons_show_more: 'Показати більше ({count})',
  cons_collapse: 'Згорнути',
  spec1: 'Лікар · терапія ожиріння',
  spec_tele: 'Лікар · сімейна медицина',
  cons_find_point: 'Знайти пункт',
  cons_checkup_results_btn: 'Обери час для розмови',
  cons_find_point_link: 'https://tabletka24.pl/uk/map-synevo-ua/',
  cons_download_referral: 'Завантажити направлення',
  terapia_title: 'Твоя терапія, крок за кроком',
  terapia_intro: 'Тут ми зібрали всі корисні посилання й інформацію, що можуть знадобитись під час терапії GLP-1.',
  last_visit: 'Остання візита',
  rec_control: 'Рекомендована контрольна візита',
  book_control: 'Записатись на контроль',
  uslugi_title_a: 'Перевір, з чим ще ми можемо тобі допомогти',
  cs_recepta: 'Електронний рецепт',
  cs_recepta_d: 'Ліки від алергії, застуди чи інфекції? Отримай швидко е-рецепт онлайн — <strong>59 zł</strong>',
  cs_anty: 'Контрацепція',
  cs_anty_d: 'Твоя контрацепція завжди під рукою — е-рецепт онлайн за <strong>59 zł</strong>',
  cs_l4: 'Лікарняний (L4)',
  cs_l4_d: 'Зле почуваєшся й треба відновитись? Лікар випише L4 онлайн — <strong>79 zł</strong>',
  cs_tele: 'Телепорада',
  cs_tele_d: 'Інфекція, біль чи застуда? Поговори з лікарем онлайн — <strong>79 zł</strong>',
  cs_check: 'Онлайн чекап з Synevo',
  cs_check_d: 'Подбай про себе заздалегідь — пакети аналізів <strong>від 259 zł</strong>',
  glp_t: 'Терапія схуднення (GLP-1)',
  glp_d: 'Пробувала вже все, а вага стоїть на місці? Комплексна терапія GLP-1 <strong>від 199 zł</strong>',
  svc_analizy: 'Контрольні аналізи',
  svc_analizy_d: 'Час перевірити, як організм реагує на терапію? Пакет аналізів у Synevo — <strong>299 zł</strong>',
  svc_portal: 'Портал про терапію GLP-1',
  svc_portal_d: 'Хочеш зрозуміти, як працюють аналоги GLP-1? Зазирни в портал знань',
  doc_all: 'Усі',
  doc_recepty: 'Рецепти',
  doc_skier: 'Направлення',
  doc_wyniki: 'Результати аналізів',
  doc_moje: 'Мої файли',
  doc_l4: 'Лікарняні',
  doc_zalecenia: 'Рекомендації',
  add_file: 'Додати файл',
  empty_doc: 'Тут з\'являться твої документи',
  add_file_sub: 'Додай документ — лікар побачить його під час консультації',
  upload_txt: 'Перетягни файл або клікни тут',
  upload_max: '(Макс. розмір файлу: 100 МБ)',
  upload_formats: 'Доступні формати: .pdf, .jpg, .jpeg, .png, .doc, .docx',
  upload_blocked_hint: 'Можливість додавання файлів відкриється після першої консультації',
  doc_delete_confirm: 'Ви впевнені, що хочете видалити цей файл?',
  doc_title_desktop: 'Документи',
  doc_title_mobile: 'Документація',
  doc_no_files: 'Немає файлів',
  doc_default_name: 'Документ',
  doc_upload_title: 'Завантажити новий документ',
  doc_close: 'Закрити',
  doc_choose_file: 'Вибрати файл з пристрою',
  doc_uploaded_file: 'Завантажений файл',
  doc_delete_selected: 'Видалити обраний файл',
  doc_send_to_doctor: 'Надіслати лікарю',
  doc_prescription_title: 'Рецепт',
  doc_prescription_code: 'Код рецепту',
  doc_code: 'Код',
  doc_pickup_title: 'Як отримати ліки в аптеці?',
  doc_pickup_desc_1: 'Достатньо назвати фармацевту ',
  doc_pickup_desc_2: 'номер PESEL',
  doc_pickup_desc_3: ' та ',
  doc_pickup_desc_4: 'код рецепту',
  doc_prescriptions_heading: 'РЕЦЕПТИ',
  doc_download_pdf: 'Завантажити (PDF)',
  doc_print_save_pdf: 'Друкувати / Зберегти PDF',
  doc_all_files: 'Усі файли',
  dane_personal: 'Персональні дані',
  dane_addr: 'Адресні дані',
  dane_contact: 'Контактні дані',
  security: 'Безпека',
  sex: 'Стать',
  female: 'Жінка',
  male: 'Чоловік',
  tz: 'Часовий пояс',
  street: 'Вулиця',
  city: 'Місто',
  country: 'Країна',
  phone_short: 'Телефон',
  err_phone: 'Невірний номер телефону',
  edit: 'Редагувати',
  change: 'Змінити',
  cancel: 'Скасувати',
  save: 'Зберегти',
  edit_your: 'Редагуй свої дані',
  resch_title: 'Перенести візит',
  resch_intro: 'Твої плани змінились? Перенеси консультацію в кілька кліків.',
  resch_current: 'Твій новий час',
  resch_doctor: 'Обери лікаря',
  resch_pick: 'Обери час',
  resch_confirm: 'Підтвердити новий час',
  resch_ok_t: 'Візит перенесено',
  resch_ok_s: 'Твій візит перенесено. Підтвердження надіслали на e-mail',
  back_cons: 'Назад до консультацій',
  toast_soon: 'Скоро буде доступно',
  toast_portal: 'Перехід до порталу знань…',
  toast_added: 'Файл додано',
  toast_saved: 'Зміни збережено',
  toast_pass: 'Відкриваю зміну пароля…',
  toast_deleted: 'Файл видалено',
  verify_email_banner: 'Підтверди свою e-mail-адресу, щоб отримати доступ до медичної документації.',
  verify_email_cta: 'Надіслати посилання для підтвердження',
  verify_email_sent: 'Посилання надіслали на твій e-mail.',
  verify_email_title_existing: 'Підтверди e-mail і встанови пароль',
  verify_email_sub_existing: 'У твоєму акаунті вже є e-mail. Підтверди його та встанови пароль, щоб входити не лише за SMS-кодом, а й за e-mail.',
  set_new_password_title: 'Встановіть новий пароль',
  set_new_password_sub: 'Введіть новий пароль для вашого акаунту',
  new_password_placeholder: 'Новий пароль (мін. 8 символів)',
  confirm_password_placeholder: 'Повторіть новий пароль',
  set_password_btn: 'Зберегти пароль',
  password_set_success: 'Пароль успішно змінено! Виконується вхід...',
  err_password_short: 'Пароль повинен містити щонайменше 8 символів.',
  err_passwords_mismatch: 'Введені паролі не збігаються',
  my_account: 'Мій акаунт',
  passport_no: 'Серія та номер паспорта',
  issue_country: 'Країна видачі',
  issue_date: 'Дата видачі',
  building: 'Номер будинку/квартири',
  zipcode: 'Поштовий індекс',
  email: 'E-mail',
  push_notif: 'Push-сповіщення',
  push_off_toast: 'Сповіщення вимкнено',
  push_on_toast: 'Сповіщення увімкнено',
  push_err_toast: 'Помилка активації сповіщень',
  turn_off: 'Вимкнути',
  turn_on: 'Увімкнути',
  add_email_title: 'Додайте e-mail до акаунту',
  add_email_sub: 'Ваш акаунт зареєстровано лише за номером телефону. Додайте e-mail, щоб мати змогу увійти та відновити пароль.',
  add_email_btn: 'Додати e-mail',
  err_email_send: 'Помилка відправки листа. Спробуйте ще раз.',
  terms_link: 'Ознайомся з <u>Регламентом сервісу</u>',
  privacy_link: 'Ознайомся з <u>Політикою конфіденційності</u>',
  error_save: 'Сталася помилка під час збереження',
  sending: 'Надсилання...',
  poland: 'Польща',
  ther_welcome_sub: 'Нижче знайдеш усе необхідне для терапії схуднення препаратами GLP-1',
  ther_next_visit: 'Наступний контрольний візит',
  ther_rec_date: 'Рекомендована дата:',
  ther_book_visit: 'Записатись на контроль',
  ther_my_visits: 'Мої візити',
  ther_visits_desc: 'Історія та майбутні консультації',
  ther_tests: 'Контрольні аналізи',
  ther_tests_desc: 'Зробіть спеціальний пакет аналізів для терапії в Synevo - 299 zł',
  ther_portal: 'Портал знань про терапію',
  ther_portal_desc: 'Як використовувати препарати, про харчування та фізичну активність',
  ther_extra_services: 'Додаткові послуги',
  ther_extra_services_desc: 'Замовте консультації з дієтологом, план харчування',
  doc_delete_err: 'Не вдалося видалити файл',
  doc_delete_btn: 'Видалити',
  thanks_desc: 'Твій запит прийнято. Про наступні кроки повідомимо тебе електронною поштою та у сповіщеннях.',
  thanks_no_order: 'Дякуємо за замовлення! Деталі знайдеш у своєму акаунті.',
  back_to_dashboard: 'Повернутися на головну',
  sick_note_from_to: '<span style="font-size: 12px;">з</span> {from} <span style="font-size: 12px;">до</span> {to}',
  err_load_slots: 'Виникла помилка під час завантаження термінів.',
  err_resch: 'Помилка під час перенесення візиту.',
  resch_ok_p1: 'Ваш візит перенесено на {date}.',
  resch_ok_p2: 'Підтвердження ми надіслали на email.',
  med_cons: 'Медична консультація',
  loading_slots: 'Завантаження термінів…',
  no_avail_slots: 'Немає вільних термінів',
  resch_new_time: 'Ваш новий час',
  any_doctor: 'Будь-який лікар',
  doc_placeholder: 'Лікар',
  resch_select_date: 'Вибрати',
  weekdays_short: 'Пн,Вт,Ср,Чт,Пт,Сб,Нд',
  synevo_any_point: 'Виконайте в будь-якому відділенні Synevo',
  pwa_banner_title: 'Встановіть додаток',
  pwa_banner_sub: 'Додай застосунок на головний екран і <strong>отримай -15%</strong> на перше замовлення з застосунку',
  pwa_banner_how: 'Як встановити?',
  pwa_exp_title: 'Встановіть Tabletka24',
  pwa_exp_sub: 'Встанови застосунок, <strong>отримай -15% на замовлення</strong> й користуйся додатковими бонусами та сповіщеннями',
  pwa_welcome_coupon: 'Привіт! Отримай -15% на перше замовлення з застосунку за кодом <b>WELCOME15</b>',
  pwa_back: 'Повернутися',
  pwa_s_1: '1. Натисніть кнопку внизу екрана',
  pwa_s_2: '2. Далі натисніть кнопку',
  pwa_s_2_badge: 'Поділитися',
  pwa_s_3: '3. Прокрутіть меню та виберіть',
  pwa_s_3_badge: 'Додати на екран "Додому"',
  pwa_s_4: '4. Введіть назву та натисніть кнопку',
  pwa_s_4_badge: 'Додати',
  pwa_s_4_end: 'у правому верхньому куті',
  pwa_ci_1: '1. Натисніть кнопку вгорі екрана',
  pwa_ci_1_mid: 'або знайдіть кнопку',
  pwa_ci_1_badge: 'Показати більше',
  pwa_ca_1: '1. Натисніть меню',
  pwa_ca_1_end: 'у правому верхньому куті',
  pwa_ca_3: '3. Підтвердіть, натиснувши',
  pwa_ca_3_badge1: 'Встановити',
  pwa_ca_3_mid: 'або',
  pwa_ca_3_badge2: 'Додати',
  tour_back: 'Назад',
  tour_next: 'Далі',
  tour_finish: 'Готово',
  tour_welcome: 'Привіт! Вітаємо у твоєму кабінеті пацієнта 👋 За кілька кроків покажемо, що і де знайдеш.',
  tour_notif: 'Тут твої сповіщення — повідомимо, коли зʼявляться результати аналізів, нові документи чи залецення лікаря.',
  tour_a1: 'Тут нагадаємо про рекомендовану дату контрольного візиту — запишешся в один клік.',
  tour_a2: 'У «Моїх консультаціях» — повна історія візитів: перенесеш час і запишешся знову. Там же відкриєш підсумок кожного візиту — рекомендації лікаря та документи.',
  tour_a3: 'У вкладці «Послуги» замовиш наші додаткові послуги поза терапією — е-рецепт, телепораду, L4 чи пакет аналізів.',
  tour_a4: 'У «Документах» — твої рецепти, направлення, рекомендації лікаря та результати аналізів. Можеш додати й свій файл.',
  tour_a5: 'У «Моїх даних» зміниш свої дані, встановиш пароль для входу та зміниш налаштування акаунту.',
  tour_b1: 'У «Записатись» замовиш е-рецепт, телепораду, L4, контрацепцію або пакет аналізів.',
  tour_b2: 'У «Консультаціях» — історія візитів і замовлень: перенесеш час, а також відкриєш підсумок візиту — рекомендації лікаря та документи.',
  tour_b3: 'У «Документах» — твої рецепти, лікарняні, направлення та результати аналізів.',
  tour_b4: 'У «Моїх даних» зміниш свої дані, встановиш пароль для входу та зміниш налаштування акаунту.',
  tour_pwa: 'Встанови кабінет як застосунок на головний екран телефону — відкриватимеш його одним дотиком, як звичайну аплікацію.',
  loading_dots: 'Завантаження...',
  err_login_invalid: 'Невірна адреса e-mail або пароль',
  email_placeholder: 'E-mail*',
  show_hide_password: 'Показати/сховати пароль',
  err_email_invalid: 'Введіть коректну адресу e-mail.',
  err_firstname_latin: 'Будь ласка, введіть ім\'я латиницею (напр. Natalia).',
  err_lastname_latin: 'Будь ласка, введіть прізвище без пробілів і латиницею (напр. Kovalchuk).',
  err_email_exists: 'Цей e-mail вже зайнятий.',
  err_rate_limit_10m: 'Забагато спроб. Зачекайте 10 хвилин.',
  err_register_failed: 'Реєстрація не вдалася. Спробуйте ще раз.',
  err_reset_send: 'Помилка під час надсилання посилання.',
  powrot: 'Назад',
  reset_pw_sub: 'Введіть e-mail, щоб скинути пароль.',
  err_set_password: 'Помилка під час встановлення пароля. Посилання могло застаріти.',
  auth_ready: 'Готово!',
  auth_redirect_msg: 'Акаунт успішно створено. Зараз тебе буде перенаправлено...',
  push_prompt_msg: 'Бажаєте увімкнути push-сповіщення, щоб не пропустити важливу інформацію?',
  notifications: 'Сповіщення',
  no_notifications: 'Немає сповіщень',
  err_phone_min9: 'Вкажіть правильний номер телефону (мін. 9 цифр)',
  err_street_invalid: 'Вкажіть правильну назву вулиці',
  err_city_invalid: 'Вкажіть правильну назву міста',
  house_number: 'Номер будинку/приміщення',
  zip_code: 'Поштовий індекс',
  empty_cons_btn: 'Записатись на візит',
  empty_cons_title: 'У вас ще немає візитів',
  dr_prefix: 'Лікар',
  synevo_package: 'Пакет аналізів в Synevo',
  blood_tests_package: 'Пакет аналізів крові',
  doctor_alt: 'Лікар',
  err_fetch_recommendations: 'Не вдалося отримати рекомендації',
  doctor_recommendations: 'Рекомендації лікаря',
  dietitian_recommendations: 'Рекомендації дієтолога',
  visit_no: 'Візит',
  no_recommendations: 'Немає рекомендацій для цього візиту.',
  err_upload_file: 'Помилка при завантаженні файлу',
  no_visit_data: 'Немає даних про візит.',
  diagnosis: 'Діагноз',
  e_prescription: 'Електронний рецепт',
  e_prescription_code: 'Код е-рецепта:',
  referrals_title: 'Направлення',
  code_label: 'Код:',
  test_results_docs: 'Результати аналізів / Документи',
  password_placeholder: 'Пароль*',
  prescription_title: 'Рецепт',
  referral: 'Направлення',
  print_save_pdf: 'Друк / Зберегти PDF',
  close: 'Закрити',
  push_later: 'Пізніше',
  doc_referral_title: 'Направлення',
  doc_referral_code: 'Код е-направлення',
  doc_referral_type: 'Тип направлення',
  doc_referral_diseases: 'Діагнози',
  doc_referral_procedures: 'Дослідження / Процедури',
  doc_referral_reason: 'Причина направлення',
  doc_referral_notes: 'Додаткові примітки',
  doc_referral_urgent: 'Термінове',
  doc_referral_empty: 'Немає направлень для цього візиту.',
  doc_referral_card_label: 'Направлення',
  diet_need_advice: 'Потребуєте поради дієтолога?',
  diet_need_advice_sub: 'Проконсультуйтеся з нашим експертом або замовте індивідуальне меню, адаптоване до ваших потреб.',
  diet_check_offer: 'Переглянути пропозицію',
  diet_plan_title: 'Ваш план харчування',
  diet_plan_ready: 'Готово',
  diet_plan_prep: 'В розробці',
  diet_plan_prep_desc: 'Дієтолог готує ваше меню. Ми повідомимо вас електронною поштою (зазвичай до 2 днів).',
  diet_plan_slot: '📅 Запланована консультація: {slot}',
  diet_plan_desc: 'Меню на 30 днів від дієтолога — з рецептами та списком покупок.',
  diet_plan_open: 'Відкрити план',
  diet_plan_download: 'Завантажити PDF',
  diet_plan_reorder: 'Замовити наступний місяць (99 zł)',
  diet_plan_meet: 'Консультація: Google Meet',
  diet_plan_zalecenia: 'Рекомендації від дієтолога:',
};
